import {Form, Input, InputProps, Tooltip, Typography} from 'antd';
import React, {memo} from 'react';
import './AppInputText.scss';
import {ExclamationCircleOutlined} from "@ant-design/icons";

type AppInputTextProps = InputProps & {
  containerClassName?: string;
  label: string;
  value?: string;
  placeholder?: string;
  regex?: RegExp;
  isAllowToolTip?: boolean;
  toolTipTitle?: React.FC;
  alert?: string;
  error?: string;
  onValidationChanged?: (status: boolean) => void;
  onInputChanged?: (newValue: string) => void;
};

const AppInputText: React.FC<AppInputTextProps> = ({
  containerClassName,
  label,
  value,
  placeholder,
  regex,
  isAllowToolTip,
  toolTipTitle : ToolTipTitle,
  alert,
  onValidationChanged,
  error,
  onInputChanged,
  ...rest
}) => {
  return (
    <div className={`app-input-text-container ${containerClassName}`}>
      <p className="app-input-text-label" >
        {label}
        <span className="app-input-text-required">{rest.required && ' *'}</span>
        {isAllowToolTip &&
          <span>
            <Tooltip title={ToolTipTitle ? <ToolTipTitle /> : null} className="app-input-tool-tip" overlayInnerStyle={{width: "600px"}}>
              <ExclamationCircleOutlined />
            </Tooltip>
          </span>
        }
      </p>

      <Form.Item
        validateStatus={error ? 'error' : 'success'}
        style={{ marginBottom: 0 }}
        help={error}
      >
        <Input
          value={value}
          placeholder={placeholder}
          className="form-input"
          onChange={event => {
            onInputChanged?.(event.target.value);
            if (regex) {
              if (regex.test(event.target.value) || event.target.value === '') {
                onValidationChanged?.(true);
              } else {
                onValidationChanged?.(false);
              }
            }
          }}
          {...rest}
        />
      </Form.Item>
      {alert &&
	      <Typography.Text type="danger">{alert}</Typography.Text>
      }
    </div>
  );
};

export default memo(AppInputText);
